export default {
  english: {
    seeAll: 'See all',
  },
  french: {
    seeAll: 'Tout voir',
  },
  arabic: {
    seeAll: 'عرض الكل',
  },
  hebrew: {
    seeAll: 'ראה הכל',
  },
  persian: {
    seeAll: 'همه را ببینید',
  },
}
